import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import { ActionBarTags } from './action-bar.types.ts';

import ActionBarDividerStyles from './action-bar-divider.scss?inline';

@customElement(ActionBarTags.ActionBarDivider)
export class AtlActionBarDivider extends LitElement {
   
   static styles = ActionBarDividerStyles;

   render() {
      return html`<div></div>`;
   }
}
